module.exports = __webpack_public_path__ + "static/img/hezuo.ddf3a5cb.jpg";